import { Suspense, SuspenseButton } from '@common/components/utility';
import { IWellnessExamSalesItem } from '@common/models'
import { observer } from 'mobx-react';
import React from 'react'
import { Button } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import { FixedSizeList as List } from 'react-window';
import classnames from 'classnames';
import { htmlFrom, stripHTML } from '@common/utils';
import { PetCustomReminderModel } from '@common/models/PetCustomReminders';

interface IThirdPartyRemindersSalesItemTable {
    salesItems: IWellnessExamSalesItem[];
    addedSalesItems: PetCustomReminderModel[];
    addSalesItem: (reminder: PetCustomReminderModel) => void;
    suspenseTag: string;
}

export const ThirdPartyRemindersSalesItemTable = observer(({ salesItems, suspenseTag, addSalesItem, addedSalesItems }: IThirdPartyRemindersSalesItemTable) => {
    const SalesItemRow = ({ index, style }: { index: number, style: any }) => {
        const item = salesItems[index];
        const isAddedToRemindersTable = addedSalesItems.some(vsi => vsi.salesItemOptionId == item.salesItemOptionId);

        return (
            <section className='remindersTable'>
                <div role="row" style={style} className={classnames("exam-item", (isAddedToRemindersTable) && "exam-item-added", "d-flex", "d-flex-row", "align-items-center")}>
                    <div role="cell" className="exam-item-text flex-fill">{htmlFrom(item.name)} {htmlFrom(item.option)}</div>
                    <div role="cell" className="d-flex justify-content-end" style={{ width: "14rem" }} >
                        {isAddedToRemindersTable
                            ? <Button
                                disabled={true}
                                aria-label="added to visit"
                                variant="outline-primary"
                                style={{ width: "5rem" }}
                                className="exam-item-added me-2">Added</Button>
                            : <SuspenseButton
                                // Show the spinner if this item is being added to the visit. Hide it otherwise.
                                hideSpinner={true}
                                tag={suspenseTag}
                                aria-label={`add ${item.searchPattern} to visit`}
                                variant="outline-primary"
                                style={{ width: "5rem" }}
                                className='exam-item-add me-2'
                                onClick={() => addSalesItem(
                                    {
                                        salesItemOptionId: item.salesItemOptionId,
                                        salesItemName: stripHTML(`${item.name} ${item.option}`),
                                        reminded: false,
                                        reminderDays: item.reminderDays
                                    } as PetCustomReminderModel)}>Add
                            </SuspenseButton>
                        }
                    </div>
                </div>
            </section>
        )
    }

    return (
        <Suspense tag={suspenseTag} waiting={<PulseLoader />}>
            <div className="d-flex flex-column gap-2 mt-2">
                <div role="row" className="d-flex d-flex-row exam-item-header">
                    <div className="flex-fill"><strong>DESCRIPTION</strong></div>
                    <div className="d-flex justify-content-center" style={{ width: "9rem" }}><strong>ACTION</strong></div>
                </div>
                {_.isEmpty(salesItems) &&
                    <div>No sales items found.</div>
                }
                {!_.isEmpty(salesItems) &&
                    <List
                        height={280}
                        itemCount={salesItems.length}
                        itemSize={40}
                        width="100%">
                        {SalesItemRow}
                    </List>
                }
            </div>
        </Suspense>
    )
})
